import { render, staticRenderFns } from "./needDetail.vue?vue&type=template&id=1f645e30&scoped=true&"
import script from "./needDetail.vue?vue&type=script&lang=js&"
export * from "./needDetail.vue?vue&type=script&lang=js&"
import style0 from "./needDetail.vue?vue&type=style&index=0&id=1f645e30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f645e30",
  null
  
)

export default component.exports